export async function isEnabled(registration) {
    let subscription = await registration.pushManager.getSubscription();
    console.log('isEnabled', subscription);

    return !!subscription;
}

/**
 *
 * @param {Api} api
 * @param {ServiceWorkerRegistration} registration
 * @return {Promise<void>}
 */
export async function enable(api, registration) {
    let subscription = await registration.pushManager.getSubscription();
    console.log('sub', subscription);

    if (!subscription) {
        let key = await api.getVapidKey();
        let applicationServerKey = urlBase64ToUint8Array(key.public);

        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey
        });
    }

    await api.registerPush(subscription);
}
/**
 *
 * @param {Api} api
 * @param {ServiceWorkerRegistration} registration
 * @return {Promise<void>}
 */
export async function disable(api, registration) {
    let subscription = await registration.pushManager.getSubscription();

    if (subscription) {
        await subscription.unsubscribe();
        await api.unregisterPush(subscription);
    }
}


/*
urlBase64ToUint8Array is from
https://github.com/mozilla/serviceworker-cookbook/blob/master/tools.js

The MIT License (MIT)

Copyright (c) 2015 Harald Kirschner

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

// This function is needed because Chrome doesn't accept a base64 encoded string
// as value for applicationServerKey in pushManager.subscribe yet
// https://bugs.chromium.org/p/chromium/issues/detail?id=802280
function urlBase64ToUint8Array(base64String) {
    let padding = '='.repeat((4 - base64String.length % 4) % 4);
    let base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    let rawData = window.atob(base64);
    let outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
